import type { IntlShape } from 'react-intl'

import { unique } from 'lib/array/arrayUtils'
import { getTripListRowTripItemId } from './tripListCartPrices'
import type { TripListRow } from './tripListTypes'

export function getSelectedTripListRows(
  rows: Array<TripListRow>,
  selectedRowIds: Set<string>,
): Array<TripListRow> {
  return rows.filter(row => selectedRowIds.has(row.id))
}

export function getTripListRowAskAiContext(row: TripListRow): string {
  return `Ask AI about item_id=${getTripListRowTripItemId(row)} (${JSON.stringify(row.title)})`
}

export function getTripListRowsAskAiContext(rows: Array<TripListRow>): string {
  if (rows.length === 1 && rows[0]) return getTripListRowAskAiContext(rows[0])

  const rowContexts = rows.map(row => `item_id=${getTripListRowTripItemId(row)} (${JSON.stringify(row.title)})`)
  return `Ask AI about these selected itinerary items:\n${rowContexts.join('\n')}`
}

export function getTripListRowsAskAiTitle(intl: IntlShape, rows: Array<TripListRow>): string {
  if (rows.length === 1 && rows[0]) return rows[0].title

  return intl.formatMessage(
    {
      id: 'lyikWpZX-gQjJN6DET4b',
      defaultMessage: '{count, plural, one {# item selected} other {# items selected}}',
      description: 'Visible Ask AI context title for multiple selected trip planner list rows',
    },
    { count: rows.length },
  )
}

export function getTripListRowsTripItemIds(rows: Array<TripListRow>): Array<number> {
  return unique(rows.map(getTripListRowTripItemId))
}
